var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        title: "初核申请",
        visible: _vm.showDialog,
        "append-to-body": "",
        width: "50%"
      },
      on: {
        "update:visible": function($event) {
          _vm.showDialog = $event
        }
      }
    },
    [
      _c("div", { staticClass: "text" }, [
        _vm._v("\n    在公证机构申请中，应当包括对下列内容的确认："),
        _c("br"),
        _vm._v(
          "\n\n      （一）经人脸识别设备或者其他身份验证系统确定人证同一；"
        ),
        _c("br"),
        _vm._v("\n\n      （二）申请人与申请公证的事项有利害关系；"),
        _c("br"),
        _vm._v("\n\n      （三）申请人之间对申请公证的事项无争议；"),
        _c("br"),
        _vm._v(
          "\n\n      （四）申请公证的事项符合《公证法》第十一条规定的范围；"
        ),
        _c("br"),
        _vm._v(
          "\n\n      （五）申请公证的事项符合《公证法》第二十五条的规定和该公证机构在其执业区域内可以受理公证业务的范围。"
        ),
        _c("br"),
        _vm._v(
          "\n\n    前款确认结果有一项不符合规定的，办证系统应当确定公证申请不予受理。\n  "
        )
      ]),
      _c(
        "div",
        { staticClass: "btns" },
        [
          _c(
            "el-button",
            {
              attrs: { size: "small", type: "primary" },
              on: { click: _vm.approved }
            },
            [_vm._v("审批通过")]
          ),
          _c(
            "el-button",
            { attrs: { size: "small" }, on: { click: _vm.notApproved } },
            [_vm._v("不予受理")]
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }